import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function ModalLeaveSite({ show, handleClose, link }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body>
        <h3>Attention ! <br/> En cliquant sur ce lien, vous quittez notre site.</h3>
        <p>Le site web que vous avez demandé à consulter peut contenir des informations sur des produits ou des utilisations de produits qui ne sont pas validées en France. D'autre part, les mentions légales du site voixhemato.abbvie.fr ne s'appliqueront plus. Il faudra vous référer aux mentions légales du site en question.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={handleClose} href={link} target='_blank'>Continuer</Button>
        <Button variant="outline-primary" onClick={handleClose}>Annuler</Button>
      </Modal.Footer>  
    </Modal>
  );
}

export default ModalLeaveSite;